export default {
  登录已过期: 'Login has expired',
  查询地址户信息: 'Query address household information',
  获取地址户信息失败: 'Failed to obtain address account information',
  保存收货地址失败: 'Failed to save shipping address',
  收货地址: 'Shipping address',
  名字: 'Name',
  请输入名字: 'Please enter name',
  手机号: 'Phone number',
  请输入手机号: 'Please enter phone number',
  请输入邮箱: 'Please enter your email',
  地址: 'Address',
  请选择地区: 'Please select the region',
  请输入详细地址: 'Please enter detailed address',
  保存: 'Save',
  今天: 'Today',
  本月: 'This month',
  本季: 'This season',
  本年: 'This year',
  自定义时间: 'Custom time',
  至: 'To',
  取消: 'Cancel',
  确认: 'Confirm',
  总库存小于起订量:
    'The total inventory is less than the minimum order quantity',
  选规格: 'Select',
  自提: 'Pick up',
  不能输入小数: 'Decimals cannot be entered',
  '最多可填{{qualityPrecision}}位小数':
    'Up to {{qualityPrecision}} decimal places can be filled in',
  批量加购: 'Bulk purchase',
  填写数量: 'Fill in the quantity',
  确定: 'Confirm',
  以下规格库存不足: 'The following specifications are out of stock',
  已自动修改数量: 'Quantity has been automatically modified',
  '库存不足，已修改下单数量':
    'Insufficient inventory, order quantity has been modified',
  '加载中…': 'Loading…',
  删除成功: 'Successfully deleted',
  库存: 'Stock',
  购买数量: 'Qty',
  添加备注: 'Add Remarks',
  最低起订量: 'MOQ',
  '，还差': ', not even close',
  '总 数': 'Qty',
  总金额: 'Total',
  移出购物车: 'Delete',
  请输入内容: 'Please enter content',
  输入内容: 'Enter content',
  海外发货: 'Overseas Shipping',
  国内发货: 'Domestic Shipping',
  销量: 'Sold',
  单: 'orders',
  个: 'items',
  上次价: 'Last price',
  暂无货品: 'No products available yet',
  '--- 已经到底啦 ---': "--- It's the end ---",
  搜索: 'Search',
  综合: 'Overall Ranking',
  价格: 'Price',
  销售单数: 'Sales Volume',
  最新上架时间: 'Date of Listing',
  货名: 'Product Name',
  按: 'According to',
  排序: 'Sort',
  '按{{name}}排序': 'Sort by {{name}}',
  库存小于起订量: 'Inventory less than MOQ',
  '起订量为{{minNumStep}}{{unitName}}':
    'The minimum order quantity is {{minNumStep}}{{unitName}}',
  当前数量加上起订量后大于库存:
    'The current quantity plus the minimum order quantity is greater than the inventory',
  '最低起订量为{{minNumStep}}{{unitName}}':
    'The minimum order quantity is {{minNumStep}}{{unitName}}',
  '最大库存为{{stock}}{{unitName}}': 'Maximum stock is {{stock}}{{unitName}}',
  首页: 'Home',
  全部货品: 'Products',
  购物车: 'Cart',
  我的: 'Me',
  已下架: 'Removed',
  库存不足: 'Inventory shortage',
  已删除: 'Deleted',
  全部: 'All',
  买过: 'Bought',
  推荐: 'Recommend',
  新品: 'New product',
  爆品: 'Explosive items',
  促销: 'Promotion',
  请求已过期: 'The request has expired',
  进入店铺: 'Visit the Store',
  企业图片: 'Corporate pictures',
  企业介绍: 'Company Introduction',
  请求数据: 'Request data',
  加载下一页: 'Load next page',
  '请求中loading...': 'Loading request...',
  '请求出错了, {{msg}}': 'An error occurred with the request, {{msg}}',
  列表数据为空: 'List data is empty',
  注册: 'Register',
  登录: 'Log in',
  重置密码: 'Reset Password',
  获取验证码: 'Get code',
  重新发送: 'Resend',
  '请输入新密码（4-16位）': 'Please enter a new password (4-16 digits)',
  '请输入密码（4-16位）': 'Please enter password (4-16 digits)',
  请输入密码: 'Please enter password',
  请输入手机: 'Please enter mobile phone',
  请输入手机或邮箱: 'Please enter mobile phone or email',
  请再次输入密码: 'Please enter password again',
  中文: 'Chinese',
  越南语: 'Vietnamese',
  英文: 'English',
  手机号为18位以内的数字:
    'The mobile phone number must be a number within 18 digits',
  请输入正确的手机号: 'Please enter a valid phone number',
  请输入正确的邮箱号: 'Please enter a valid email address',
  请输入密码和确认密码: 'Please enter password and confirm password',
  '密码为4~16位字符': 'The password is 4~16 characters',
  两次输入的密码不一致: 'The passwords entered twice are inconsistent',
  请输入邀请码: 'Please enter the invitation code',
  '请先阅读并勾选《用户协议》和《隐私政策》':
    'Please read and check the "the Terms of Service" and "Privacy Policy" first',
  请输入验证码: 'Please enter verification code',
  '密码修改成功 请用新密码登录':
    'Password changed successfully. Please log in with new password.',
  用已有账号登录: 'Log in with existing account',
  新用户注册: 'Sign up',
  忘记密码: 'Forget password',
  请填写邀请码: 'Please fill in the invitation code',
  已阅读并同意: 'Have read and agree to',
  用户协议: 'the Terms of Service ',
  和: 'And',
  隐私政策: 'Privacy Policy',
  退出登录: 'Sign out',
  获取用户信息失败: 'Failed to obtain user information',
  我的资料: 'My Profile',
  点击登录: 'Click to Login',
  我的订单: 'My Invoices',
  待确认: 'To Confirm',
  待发货: 'To Shipping',
  '待收货/自提': 'To Receive',
  已完成: 'Completed',
  '退款/售后': 'Returns',
  上传中: 'Uploading',
  上传头像失败: 'Failed to upload avatar',
  上传成功: 'Upload successful',
  更新用户信息失败: 'Failed to update user information',
  更换头像: 'Change avatar',
  头像: 'Avatar',
  姓名: 'Name',
  公司: 'Company',
  手机: 'Cell phone',
  邮箱: 'Mail',
  我的地址: 'My address',
  待付款: 'Pending payment',
  配送中: 'Delivering',
  已发货: 'Shipped',
  已取消: 'Cancelled',
  '总额:': 'Lump sum:',
  '总量:': 'Total amount:',
  已作废订单不汇总统计: 'Canceled orders do not have summary statistics',
  物流选项: 'Shipping Option',
  '地址:': 'Address:',
  运输费: 'Shipping Fee',
  COD服务费: 'COD Service Fee',
  待自提: 'To Pickup',
  待配送: 'To Delivery',
  已作废: 'Cancelled',
  头程已发货: 'First Shipment Dispatched',
  已到中转仓: 'At Transit Warehouse',
  跨境运输中: 'Overseas Shipping',
  退货退款: 'Returns',
  下单成功: 'Order Placed Successfully',
  '订单总共(': 'Order total (',
  '项)': ' items)',
  留言: 'Message',
  '给订单留个言~': 'Leave a Message for the Seller~',
  提交订单: 'Submit Order',
  货款: 'Payment For Goods',
  运费: 'Shipping Fee',
  '合计：': 'Total: ',
  合计: 'Total',
  '点击“下单”即表示您同意': 'By clicking "Place Order" you are agreeing to',
  Epaifa的交易条款: 'Epaifa’s General Transaction Terms',
  结账: 'Check Out',
  下单: 'Place Order',
  取消成功: 'Cancel success',
  货品已成功添加到购物车: 'Goods have been successfully added to the cart',
  单据详情: 'Invoice details',
  'COD 服务费': 'COD Service Fee',
  总计: 'Total',
  实收: 'Paid',
  订单信息: 'Order information',
  店铺: 'Store',
  订单号: 'Order Num',
  交易时间: 'Transaction time',
  经手人: 'Handler',
  备注: 'Remark',
  再次购买: 'Reorder',
  单据列表: 'Invoice list',
  搜索订单: 'Search invoices',
  日期: 'Date',
  没有更多了: 'No more',
  '找不到订单哦~': "Can't find the order~",
  联系我们: 'Contact us',
  查看订单: 'View order',
  '运输费 {{currencySymbol}} {{slot1}} + COD服务费 {{currencySymbol}} {{slot2}}':
    'Transportation fee {{currencySymbol}} {{slot1}} + COD service fee {{currencySymbol}} {{slot2}}',
  价格不能小于0: 'Price cannot be less than 0',
  '最低价格需<=最高价格': 'Minimum price needs to <= maximum price',
  '最高价格需>=最低价格': 'The highest price needs to >= the lowest price',
  '整数位不能超过{{integerMaxLength}}位':
    'The integer bits cannot exceed {{integerMaxLength}} bits',
  '小数位不能超过{{pricePrecision}}位':
    'Decimal places cannot exceed {{pricePrecision}} places',
  最低价格: 'Lowest price',
  最高价格: 'Highest price',
  发货类型: 'Shipping type',
  重置: 'Reset',
  '商品找不到了…': 'The product cannot be found...',
  联系: 'Connect',
  库存不足无法下单: 'Insufficient stock, unable to place order',
  '添加成功，在购物车等你':
    'Added successfully, waiting for you in the shopping cart',
  选购: 'Shop',
  筛选: 'Filter',
  '支持货名/属性/条码': 'Support product name/attribute/barcode',
  最近搜索: 'Recent searches',
  删除: 'Delete',
  当前商品下架已删除: 'The current product has been removed from the shelves',
  '确认删除货品吗？': 'Are you sure to delete the item?',
  全选: 'All',
  '已选：': 'Items: ',
  是否清空失效货品: 'Whether to clear expired goods',
  清空成功: 'Cleared successfully',
  货品冲突: 'Product conflict',
  '{{infoChangeCount}}件货品档案变更，':
    '{{infoChangeCount}} items file changes,',
  '{{stockCount}}件货品库存不足，': '{{stockCount}} items are out of stock.',
  '{{deleteCount}}件货品下架或删除，':
    '{{deleteCount}} items have been taken off the shelves or deleted.',
  '{{deleteCount}}个货品已下架或库存不足，是否删除？':
    '{{deleteCount}} products have been removed or out of stock, would you like to delete them?',
  是否删除: 'Do you want to delete',
  件失效货品: ' Defective Items',
  清空: 'Clear',
  '购物车还是空的呐～': 'The shopping cart is still empty~',
  新: 'New',
  爆: 'Burst',
  荐: 'Recommend',
  促: 'Promotion',
  '登录已过期，请重新登录': 'Login has expired, please log in again',
  '出错了，请检查网络连接或重试':
    'An error occurred, please check your network connection or try again',
  '{{err}}，请检查网络连接或重试':
    '{{err}}, please check the network connection or try again',
  '{{msg}}，请检查网络连接或重试':
    '{{msg}}, please check your network connection or try again',
  '出错了~': 'Something went wrong~',
  大额订单说明: 'Large Order Explanation',
  '订单超过1亿，店长会主动联系您协助完成交易':
    'For orders exceeding 100 million, the store manager will proactively contact you to assist in completing the transaction',
  '超低价格，品质保证': 'Super Low Price, Quality Guaranteed',
  海外: 'Overseas',
  保税仓库: 'Bonded Warehouse',
  胡志明市: 'Ho Chi Minh City',
  运费信息: 'Shipping Info',
  邮寄方式: 'Shipping Method',
  可用的: 'Available',
  成本: 'Costs',
  服务费: 'Service Fee',
  任何数量: 'Any Amount',
  购买: 'Add to Cart',
  货品属性: 'Description',
  已指派专门的销售代表与您跟进:
    'A dedicated sales representative has been assigned to follow up with you',
  货品总计: 'Order total',
  项: 'items',
  装箱规格: 'Packaging',
  补货中: 'Restocking',
  请选择下单货品: 'Please select the product to order',
  请填写姓名: 'Please fill in your name',
  请填写联系电话: 'Please fill in your contact number',
  请填写收货地址: 'Please fill in your delivery address',
  搜索货品: 'Search For Goods',
  请输入数字: 'Please enter the number',
  体验一下: 'Experience it',
  请输入正确的手机号码: 'Please enter a valid phone number',
  请输入正确的邮箱地址: 'Please enter a valid email address',
  多语言: 'Languages',
  共: 'Total',
  种: 'items',
  不含税: 'VAT excluded',
  订单金额不在COD范围内: 'The order amount is not within the COD range',
  更多: 'More',
  获取: 'Get',
  获取邀请码: 'Get an invitation code',
  申请邀请码: 'Request for Invitation Code',
  'Zalo扫一扫，加我为好友': 'Scan this to add me on Zalo',
  预计送达: 'Receive by',
  请选择物流: 'Please select logistics',
  首页模块为空: 'Home page module is empty',
  重量: 'Gross',
  体积: 'Volume',
  探索数以百万计的定制产品满足您的业务需求:
    'Explore millions of offerings tailored to your business needs',
  推荐货品: 'Recommended products',
  手机登录: 'Mobile Login',
  邮箱登录: 'Email Login',
  门店: 'Store',
  仓库分拣中: 'Sorting in warehouse',
  分拣中: 'Sorting',
  退货中: 'Returning',
  采购中: 'In Purchasing',
  分类: 'Category',
  退换货: 'Returns',
  退换单: 'Returns',
  上传图片失败: 'Failed to upload image',
  批发价: 'Wholesale price',
  复购率: 'Repurchase rate',
  月销量: 'Monthly sales volume',
  没有找到相关商品: 'No related products found',
  商品总金额: 'Payment For Goods',
  优惠: 'Discount',
  '实付：': 'Paid:',
  退款成功: 'Refund successful',
  退货成功: 'Return successful',
  退货关闭: 'Return closed',
  请选择站点: 'Please select a site',
  分享: 'Share',
  下载所有图片: 'Download all images',
  相册: 'Album',
  正在下载: 'Downloading',
  '下载完成，在相册查看': 'Download complete, check in the album',
  新品2: 'New arrivals',
  商品分类: 'Categories',
  暂无商品2: 'No product',
  '生成图片中…': 'Generating image...',
  '新品相册！快来看看！': 'New arrivals album! Come and check them out!',
  新品分享: 'New arrivals sharing！',
  扫码查看: 'Scan to access quickly',
  下载图片: 'Download Picture',
  分享链接: 'Share Link',
  好物分享: 'Good Stuff sharing！',
  下载: 'Download',
  货品详情: 'Product Details',
  查看新品: 'View new arrivals',
  不含运费: 'Excluding shipping costs',
  '新品分享，点击查看': 'New arrivals sharing, click to view',
}
